<script>
	// JS file format...
	// JSON = JavaScript Object Notation
	
	import debts from './Publicdebt.json';
    let selectedYear;
	//Let's read in schools.json
</script>

<main>
	{#if selectedYear}
	<!-- svelte-ignore a11y-invalid-attribute -->
	<p><a on:click={() => selectedYear = null} href="#">Go back to the debt list</a></p>
	    <h1>Kenya'S debt burden in {selectedYear.Year}</h1>
		<p>The amount below was owed by month {selectedYear.Month} of {selectedYear.Year}</p>
	    <p>Domestic Debt owed {selectedYear[' DomesticDebt ']} million</p>
	    <p>External Debt owed {selectedYear[' ExternalDebt']} million</p>
	    <p>Total Debt owed {selectedYear[' Total ']} million by this period of the year</p>
		
    {:else}
	    <ul>
			<h3>KENYA'S DEBT BURDEN</h3>
			<p>Select a year to know how fast Kenya has accumulated debt over the years</p>
			{#each debts as debt}
			    <!-- svelte-ignore a11y-invalid-attribute -->
		    	<li><a on:click={() => selectedYear = debt} href="#">{debt.Year}</a></li>
	        {/each}
		</ul>	
	{/if}	
	<p>Data by Central Bank of Kenya</p>

	
</main>

<style>
	main {
		
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>